import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_kh9g2sdjb7: FaireBrandEntity = {
  token: "b_kh9g2sdjb7",
  type: "brand",
  name: "Gifts From The Farm",
  avatarUrl:
    "https://cdn.faire.com/fastly/4a898d71ddffe3f7de84fd1d78849d4af6a44a67d25aa2886268fa84705290b1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/77d8d1e1013d76cd2911f340491cab198c27c86f14bdac899d24cd3566c86b3d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/4a898d71ddffe3f7de84fd1d78849d4af6a44a67d25aa2886268fa84705290b1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/77d8d1e1013d76cd2911f340491cab198c27c86f14bdac899d24cd3566c86b3d.png",
  location: "Dana, IN, USA",
  minimumOrderDollars: 50,
  rating: 4.8,
  reviewCount: 18,
  isInsider: true,
  description:
    "Welcome to Gifts From The Farm, where simplicity meets luxury with our handcrafted soy wax candles, beeswax candles, and more. Nestled in the rural landscapes of Dana, IN, we take pride in creating high quality products that elevate your everyday moments. Each product is meticulously crafted in small batches, ensuring unparalleled quality and attention to detail. We strive to use the highest quality ingredients and eco-friendly packaging, and we won't compromise our standards, so that we can provide you with the finest products. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:08.407Z",
    importedBy: "entity-db-cli",
  },
};
